import { Logger } from "common/utility/logger/logger"
import { IStore } from "./interface/istore"

export class Upgrade {
    private versionChange: IDBVersionChangeEvent
    private database: IDBDatabase
    private stores: Array<IStore>
    constructor(database: IDBDatabase, versionChange: IDBVersionChangeEvent, stores: Array<IStore>) {
        this.versionChange = versionChange
        this.database = database
        this.stores = stores
    }

    public createStores(): boolean {
        let returnValue: boolean = true
        try {
            this.stores.forEach(storeInfo => {
                if (this.storeExists(storeInfo)) {
                    return
                }
                if (!this.storeCompatible(storeInfo)) {
                    return
                }

                Logger.debug(`Creating Object Store: '${storeInfo.Name}'`)
                const store: IDBObjectStore | undefined = this.database?.createObjectStore(storeInfo.Name, { keyPath: storeInfo.PrimaryField })

                if (storeInfo.Indexes) {
                    storeInfo.Indexes.forEach(index => {
                        Logger.debug(`Creating Index: '${index.Name}' for Object Store: '${storeInfo.Name}'`)
                        store?.createIndex(index.Name, index.Path, { unique: !!index.Unique })
                    })
                }
            });
        }
        catch {
            returnValue = false
        }
        return returnValue
    }

    private storeExists(store: IStore): boolean {
        return this.database.objectStoreNames.contains(store.Name)
    }

    private storeCompatible(store: IStore): boolean {
        const latestVersion: number = this.versionChange.newVersion ?? this.versionChange.oldVersion
        return store.minimumVersion >= this.versionChange.oldVersion && store.minimumVersion <= latestVersion 
    }
}
